"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dom_1 = require("@oozcitak/dom");
const dom_2 = require("@oozcitak/dom/lib/dom");
const util_1 = require("util");
dom_2.dom.setFeatures(false);
/**
 * Throws an error if the parser returned an error document.
 */
function throwIfParserError(doc) {
    const root = doc.documentElement;
    if (root !== null &&
        root.localName === "parsererror" &&
        root.namespaceURI === "http://www.mozilla.org/newlayout/xml/parsererror.xml") {
        const msgElement = root.firstElementChild;
        /* istanbul ignore next */
        if (msgElement === null)
            throw new Error("Error parsing XML string.");
        const msg = msgElement.getAttribute("message");
        /* istanbul ignore next */
        if (msg === null)
            throw new Error("Error parsing XML string.");
        throw new Error(msg);
    }
}
exports.throwIfParserError = throwIfParserError;
/**
 * Creates an XML document without any child nodes.
 */
function createDocument() {
    const impl = new dom_1.DOMImplementation();
    const doc = impl.createDocument(null, 'root', null);
    /* istanbul ignore else */
    if (doc.documentElement) {
        doc.removeChild(doc.documentElement);
    }
    return doc;
}
exports.createDocument = createDocument;
/**
 * Creates a DOM parser.
 */
function createParser() {
    return new dom_1.DOMParser();
}
exports.createParser = createParser;
/**
 * Sanitizes input strings with user supplied replacement characters.
 *
 * @param str - input string
 */
function sanitizeInput(str, replacement) {
    if (str == null) {
        return str;
    }
    else if (replacement === undefined) {
        return str + "";
    }
    else {
        let result = "";
        str = str + "";
        for (let i = 0; i < str.length; i++) {
            let n = str.charCodeAt(i);
            // #x9 | #xA | #xD | [#x20-#xD7FF] | [#xE000-#xFFFD] | [#x10000-#x10FFFF]
            if (n === 0x9 || n === 0xA || n === 0xD ||
                (n >= 0x20 && n <= 0xD7FF) ||
                (n >= 0xE000 && n <= 0xFFFD)) {
                // valid character - not surrogate pair
                result += str.charAt(i);
            }
            else if (n >= 0xD800 && n <= 0xDBFF && i < str.length - 1) {
                const n2 = str.charCodeAt(i + 1);
                if (n2 >= 0xDC00 && n2 <= 0xDFFF) {
                    n = (n - 0xD800) * 0x400 + n2 - 0xDC00 + 0x10000;
                    if (n >= 0x10000 && n <= 0x10FFFF) {
                        // valid surrogate pair
                        result += String.fromCodePoint(n);
                    }
                    else {
                        // invalid surrogate pair
                        result += util_1.isString(replacement) ? replacement : replacement(String.fromCodePoint(n), i, str);
                    }
                    i++;
                }
                else {
                    // invalid lone surrogate
                    result += util_1.isString(replacement) ? replacement : replacement(str.charAt(i), i, str);
                }
            }
            else {
                // invalid character
                result += util_1.isString(replacement) ? replacement : replacement(str.charAt(i), i, str);
            }
        }
        return result;
    }
}
exports.sanitizeInput = sanitizeInput;
//# sourceMappingURL=dom.js.map